import { Injectable } from '@angular/core';
import { BulkOperationFailure } from '../enums/bulk-operation-failure.enum';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { BulkOperationResult } from '../../core/models/bulk-operation-result.model';
import { FailedBulkOperationData } from '../../core/models/failed-bulk-operation-data.model';

@Injectable({
    providedIn: 'root',
})
export class BulkOperationsNotificationService {
    constructor(
        private translateService: TranslateService,
        private notificationsService: NotificationsService,
    ) {}

    showNotificationForTickets(result: BulkOperationResult): void {
        if (!result.areAllChangesSuccessful) {
            this.showNotificationForFailedTickets(result.failures);
        } else {
            this.showNotificationForSucceededTickets(result.succeededIds);
        }
    }

    // todo: change links formation
    private getLinkToTicket(ticketId: number): string {
        let linkToTicket: string;
        if (window.location.href.indexOf('ticketId') === -1) {
            linkToTicket = window.location.href + '&ticketId=' + ticketId;
        } else {
            linkToTicket = window.location.href.replace(/ticketId=([0-9]*)/gi, 'ticketId=' + ticketId);
        }

        return (
            '<a target="_blank" href="' + linkToTicket + '" onclick="event.stopPropagation();">#' + ticketId + '</a>'
        );
    }

    private showNotificationForFailedTickets(failures: FailedBulkOperationData[]): void {
        let failureMessage = '<ul>';
        failures.forEach((failure: FailedBulkOperationData) => {
            failureMessage += '<li>';

            switch (failure.reason) {
                case BulkOperationFailure.maxBatchSizeReached: {
                    failureMessage += this.translateService.instant('maximum batch size was reached: ');
                    break;
                }
                case BulkOperationFailure.ticketNotFound: {
                    failureMessage += this.translateService.instant('tickets were not found: ');
                    break;
                }
                case BulkOperationFailure.ticketIsAssignedToBot: {
                    failureMessage += this.translateService.instant('tickets are assigned to bot: ');
                    break;
                }
                case BulkOperationFailure.notAllowedToChangeTicketAssignee: {
                    failureMessage += this.translateService.instant('not allowed to change ticket assignee: ');
                    break;
                }
                case BulkOperationFailure.alreadyUpdatedTicket: {
                    failureMessage += this.translateService.instant('tickets were already updated: ');
                    break;
                }
                case BulkOperationFailure.notAllowedToChangeCategoryDueToZissonInteract: {
                    failureMessage += this.translateService.instant(
                        'not allowed to change category due to Zisson Interact: ',
                    );
                    break;
                }
                case BulkOperationFailure.ticketIsAssignedToAnotherUser: {
                    failureMessage += this.translateService.instant('tickets are assigned to another user: ');
                    break;
                }
                case BulkOperationFailure.notAllowedToChangeStatusDueToMissingRequiredCategory: {
                    failureMessage += this.translateService.instant('tickets must have category to be closed: ');
                    break;
                }
                case BulkOperationFailure.notAllowedToChangeStatusDueToMissingRequiredTags: {
                    failureMessage += this.translateService.instant('tickets must have tags to be closed: ');
                    break;
                }
                case BulkOperationFailure.notAllowedToChangeStatusDueToMissingRequiredTeamFields: {
                    failureMessage += this.translateService.instant(
                        'Required for Agents fields must be filled to close the ticket',
                    );
                    break;
                }
                case BulkOperationFailure.ticketSourceIsDeprecated: {
                    failureMessage += this.translateService.instant(
                        'tickets cannot be edited due to a deprecated source: ',
                    );
                    break;
                }
                case BulkOperationFailure.unexpectedError:
                default: {
                    failureMessage += this.translateService.instant('unknown error: ');
                }
            }

            const ticketLinks = failure.ids
                .map((ticketId: number) => {
                    return this.getLinkToTicket(ticketId);
                })
                .join(', ');

            failureMessage += ticketLinks + '</li>';
        });

        failureMessage += '</ul>';

        this.notificationsService.warn(this.translateService.instant('Some tickets were not updated'), failureMessage, {
            timeOut: 0,
        });
    }

    private showNotificationForSucceededTickets(succeededIds: number[]): void {
        this.notificationsService.success(
            this.translateService.instant('Success'),
            succeededIds.length + ' ' + this.translateService.instant('ticket(s) were updated'),
            {
                timeOut: 0,
            },
        );
    }
}
